var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled from "@emotion/styled";
import { diffLines } from "diff";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { convertToNumber } from "@/lib/helpers";
import { Button } from "react-admin";
import { Dialog } from "@sequentech/ui-essentials";
import { debounce } from "lodash";
var DiffViewStyled = {
    Header: styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        font-family: Roboto;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 24px;\n        letter-spacing: 0.4000000059604645px;\n        text-align: left;\n        text-transform: uppercase;\n    "], ["\n        font-family: Roboto;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 24px;\n        letter-spacing: 0.4000000059604645px;\n        text-align: left;\n        text-transform: uppercase;\n    "]))),
    Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        gap: 16px;\n        display: flex;\n        justify-content: space-around;\n    "], ["\n        gap: 16px;\n        display: flex;\n        justify-content: space-around;\n    "]))),
    Content: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        gap: 12px;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    "], ["\n        gap: 12px;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    "]))),
    Block: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        background-color: #f5f5f5;\n        padding: 16px;\n        height: 100%;\n        width: 100%;\n        max-height: 500px;\n    "], ["\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        background-color: #f5f5f5;\n        padding: 16px;\n        height: 100%;\n        width: 100%;\n        max-height: 500px;\n    "]))),
    Json: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        width: 100%;\n        max-width: 35vw;\n        overflow-x: scroll;\n    "], ["\n        width: 100%;\n        max-width: 35vw;\n        overflow-x: scroll;\n    "]))),
    Removed: styled.pre(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        width: 100%;\n        font-size: 12px;\n        background-color: #fa958e;\n        text-decoration: line-through;\n    "], ["\n        width: 100%;\n        font-size: 12px;\n        background-color: #fa958e;\n        text-decoration: line-through;\n    "]))),
    Added: styled.pre(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        width: 100%;\n        font-size: 12px;\n        background-color: #43e3a1;\n    "], ["\n        width: 100%;\n        font-size: 12px;\n        background-color: #43e3a1;\n    "]))),
    Line: styled.pre(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        width: 100%;\n        font-size: 12px;\n    "], ["\n        width: 100%;\n        font-size: 12px;\n    "]))),
    Loading: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        display: flex;\n        height: 60vh;\n        justify-content: center;\n        align-items: center;\n    "], ["\n        display: flex;\n        height: 60vh;\n        justify-content: center;\n        align-items: center;\n    "]))),
};
var TRUNCATION_STATE;
(function (TRUNCATION_STATE) {
    TRUNCATION_STATE[TRUNCATION_STATE["NOT_NEEDED"] = 0] = "NOT_NEEDED";
    TRUNCATION_STATE[TRUNCATION_STATE["TRUNCATED"] = 1] = "TRUNCATED";
    TRUNCATION_STATE[TRUNCATION_STATE["UNTRUNCATED"] = 2] = "UNTRUNCATED";
})(TRUNCATION_STATE || (TRUNCATION_STATE = {}));
// Truncate the strings if they are too long
var truncateLines = function (str, maxLines) {
    var lines = str.split("\n");
    if (lines.length > maxLines) {
        return lines.slice(0, maxLines).join("\n") + "\n...";
    }
    return str;
};
var DiffViewMemo = React.memo(function (_a) {
    var _b;
    var current = _a.current, currentTitle = _a.currentTitle, modify = _a.modify, diffTitle = _a.diffTitle, _c = _a.type, type = _c === void 0 ? "modify" : _c, fetchAllPublishChanges = _a.fetchAllPublishChanges;
    var MAX_DIFF_LINES = (_b = convertToNumber(process.env.MAX_DIFF_LINES)) !== null && _b !== void 0 ? _b : 500;
    var _d = useState(""), diff = _d[0], setDiff = _d[1];
    var t = useTranslation().t;
    var _e = useState(""), oldJsonString = _e[0], setOldJsonString = _e[1];
    var _f = useState(""), newJsonString = _f[0], setNewJsonString = _f[1];
    var _g = useState(false), showDialog = _g[0], setShowDialog = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var _j = useState(TRUNCATION_STATE.NOT_NEEDED), truncationState = _j[0], setTruncationState = _j[1];
    var memoizedModify = useMemo(function () { return (modify ? JSON.stringify(modify, null, 2) : ""); }, [modify]);
    var memoizedCurrent = useMemo(function () { return (current ? JSON.stringify(current, null, 2) : ""); }, [current]);
    useEffect(function () {
        if (!memoizedModify || truncationState !== TRUNCATION_STATE.NOT_NEEDED)
            return;
        var lines = memoizedModify.split("\n");
        if (lines.length < MAX_DIFF_LINES)
            return;
        setTruncationState(TRUNCATION_STATE.TRUNCATED);
    }, [memoizedModify, MAX_DIFF_LINES, truncationState]);
    useEffect(function () {
        if (truncationState === TRUNCATION_STATE.TRUNCATED) {
            setNewJsonString(truncateLines(memoizedModify, MAX_DIFF_LINES));
            setOldJsonString(truncateLines(memoizedCurrent, MAX_DIFF_LINES));
        }
        else {
            setNewJsonString(memoizedModify);
            setOldJsonString(memoizedCurrent);
        }
    }, [truncationState, memoizedCurrent, memoizedModify, MAX_DIFF_LINES]);
    var calculateDiff = useCallback(debounce(function () {
        if (newJsonString || oldJsonString) {
            var diffText = diffLines(oldJsonString, newJsonString);
            setDiff(diffText);
        }
    }, 100), [oldJsonString, newJsonString]);
    useEffect(function () {
        calculateDiff();
        return function () {
            calculateDiff.cancel();
        };
    }, [calculateDiff]);
    var handleDialogClose = useCallback(function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var shouldUpdateData_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!result) return [3 /*break*/, 2];
                    shouldUpdateData_1 = false;
                    setTruncationState(function (prev) {
                        if (prev === TRUNCATION_STATE.TRUNCATED) {
                            shouldUpdateData_1 = true;
                            return TRUNCATION_STATE.UNTRUNCATED;
                        }
                        return TRUNCATION_STATE.TRUNCATED;
                    });
                    if (!shouldUpdateData_1) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, fetchAllPublishChanges()];
                case 1:
                    _a.sent();
                    setLoading(false);
                    _a.label = 2;
                case 2:
                    setShowDialog(false);
                    return [2 /*return*/];
            }
        });
    }); }, [fetchAllPublishChanges]);
    if (!diff) {
        return (_jsx(DiffViewStyled.Loading, { children: _jsx(CircularProgress, {}) }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs(DiffViewStyled.Container, { children: [_jsxs(DiffViewStyled.Content, { children: [_jsx(DiffViewStyled.Header, { children: currentTitle }), _jsxs(DiffViewStyled.Block, { children: [_jsx(DiffViewStyled.Json, { children: diff === null || diff === void 0 ? void 0 : diff.map(function (line, index) {
                                            return !line.added ? (line.removed && type === "modify" ? (_jsx(DiffViewStyled.Removed, { children: line.value }, index)) : (_jsx(DiffViewStyled.Line, { children: line.value === "null"
                                                    ? t("common.label.loadingData")
                                                    : line.value }, index))) : null;
                                        }) }), truncationState !== TRUNCATION_STATE.NOT_NEEDED && (_jsx(Button, { onClick: function () {
                                            if (truncationState === TRUNCATION_STATE.UNTRUNCATED) {
                                                setTruncationState(TRUNCATION_STATE.TRUNCATED);
                                            }
                                            else {
                                                setShowDialog(true);
                                            }
                                        }, label: truncationState === TRUNCATION_STATE.TRUNCATED
                                            ? t("electionEventScreen.common.showMore")
                                            : t("electionEventScreen.common.showLess"), style: {
                                            color: "#fff",
                                            width: "fit-content",
                                            minHeight: "unset",
                                            fontSize: "0.8rem",
                                            position: "absolute",
                                            right: "0.5rem",
                                            bottom: "0.5rem",
                                        }, "aria-expanded": truncationState !== TRUNCATION_STATE.TRUNCATED, "aria-controls": "diff-content" }))] })] }), type === "modify" && (_jsxs(DiffViewStyled.Content, { children: [_jsx(DiffViewStyled.Header, { children: diffTitle }), _jsxs(DiffViewStyled.Block, { children: [_jsx(DiffViewStyled.Json, { children: diff === null || diff === void 0 ? void 0 : diff.map(function (line, index) {
                                            return !line.removed ? (line.added ? (_jsx(DiffViewStyled.Added, { children: line.value }, index)) : (_jsx(DiffViewStyled.Line, { children: line.value === "null"
                                                    ? t("common.label.loadingData")
                                                    : line.value }, index))) : null;
                                        }) }), truncationState !== TRUNCATION_STATE.NOT_NEEDED && (_jsx(Button, { onClick: function () {
                                            if (truncationState === TRUNCATION_STATE.UNTRUNCATED) {
                                                setTruncationState(TRUNCATION_STATE.TRUNCATED);
                                            }
                                            else {
                                                setShowDialog(true);
                                            }
                                        }, label: truncationState === TRUNCATION_STATE.TRUNCATED
                                            ? t("electionEventScreen.common.showMore")
                                            : t("electionEventScreen.common.showLess"), style: {
                                            color: "#fff",
                                            width: "fit-content",
                                            minHeight: "unset",
                                            fontSize: "0.8rem",
                                            position: "absolute",
                                            right: "0.5rem",
                                            bottom: "0.5rem",
                                        }, "aria-expanded": truncationState !== TRUNCATION_STATE.TRUNCATED, "aria-controls": "diff-content" }))] })] }))] }), _jsx(Dialog, __assign({ variant: "warning", open: showDialog, ok: t("publish.dialog.ok"), cancel: t("publish.dialog.ko"), title: t("publish.dialog.title"), handleClose: handleDialogClose, okEnabled: function () { return !loading; } }, { children: _jsxs(DiffViewStyled.Content, { children: [t("publish.dialog.diff"), loading && _jsx(CircularProgress, {})] }) }))] }));
});
DiffViewMemo.displayName = "DiffView";
export var DiffView = DiffViewMemo;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
